import { FullViewBlock, FullViewItem } from 'components/FullView';
import { groupBy } from 'helpers';
import { Group } from 'helpers/groupBy';
import { getMetaDataValue } from 'helpers/metaData';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { MetaDataAccess, MetaDataValue } from 'types/metadata';

type Props = {
  metaData: MetaDataValue[];
};

export const MetaDataInfoView: React.FC<Props> = ({ metaData }: Props) => {
  const { t } = useTranslation(['metaData', 'global']);
  const groupedMetaData =
    (metaData && metaData.length) > 0 ? (groupBy(metaData, 'category') as Group<MetaDataValue>) : [];

  return metaData && metaData.length > 0 ? (
    <React.Fragment>
      {Object.entries(groupedMetaData).map(([key, groupedMd]) => {
        return groupedMd.filter((meta: MetaDataValue) => meta.accessibility !== MetaDataAccess.Hidden).length > 0 ? (
          <FullViewBlock key={key}>
            <h2 className="block-title">{key !== 'undefined' ? key : t('global:general.other')}</h2>
            <div className="block-data">
              {groupedMd.map(
                (item: MetaDataValue, index: number) =>
                  item.accessibility === 'readOnly' ||
                  (item.accessibility === 'editable' && (
                    <FullViewItem
                      key={index}
                      label={t(`metaData:${item.code?.toUpperCase()}`) || ''}
                      value={getMetaDataValue(item)}
                    />
                  ))
              )}
            </div>
          </FullViewBlock>
        ) : null;
      })}
    </React.Fragment>
  ) : null;
};
